import { useEffect } from 'react';

const BASE = 'NEAT Systems';

/** Sets the document <title> and meta description for the current page. */
export const useDocumentTitle = (title?: string, description?: string) => {
  useEffect(() => {
    document.title = title
      ? `${title} — ${BASE}`
      : `${BASE} — Enterprise IT Infrastructure Solutions`;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
};
